import { createGlobalStyle } from "styled-components"
import utilities from './utilities';
import modal from './modal';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: 'Merriweather Sans', sans-serif;
  }

  #root {
    input, .form-control {
      font-size: 0.8rem;
      font-weight: 300;

      &::placeholder {
        color: ${({ theme }) => theme.palette.grayscale[4]};
        font-style: italic;
      }
    }
    div[class*=placeholder] {
      color: ${({ theme }) => theme.palette.grayscale[4]};
      font-style: italic;
      font-size: 0.8rem;
      font-weight: 300;
    }
  }
  
  form {
    .edit-mode {
      display: none;
    }
    &.edit, .edit {
      .table {
        width: 100%;
      }
      .view-mode {
        display: none;
      }
      .edit-mode {
        display: block;
      }
    }

    .editable {
      &:hover {
        .edit-toolbar {
          visibility: visible;
        }
      }
      &:hover.edit {
        .edit-toolbar {
          visibility: hidden;
        }
      }
    }
  }
  
  ${utilities}
  ${modal}
`

export default GlobalStyle
